/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Item_NameInputs */

const vi_einvoice_draft_item_name = /** @type {(inputs: Einvoice_Draft_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên hàng`)
};

/**

* @param {Einvoice_Draft_Item_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_item_name = /** @type {((inputs?: Einvoice_Draft_Item_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Item_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_item_name(inputs)
});